import classes from "./main.module.css";
import React, {useCallback, useEffect, useState} from 'react';
import AnimatedPage from "../../animations/AnimatedPage";
import yandex_map from "../../images/yandex-map.png"
import telegram from "../../images/telegram.svg"
import News from "../../components/news/News";
import {getNews} from "../../clients/NewsApiClient";
import CreateButton from "../../components/buttons/CreateButton";
import CreateNewsForm from "../../components/forms/CreateNewsForm";
import {useAuth} from "../../context/AuthContext";
import {NewsContext} from "../../context/NewsContext";
import DeleteNewsForm from "../../components/forms/DeleteNewsForm";
import {UpdatePhotoForm} from "../../components/forms/UpdatePhotoForm";


const Main = () => {

    const [deleteIsOpen, setDeleteIsOpen] = useState(false);
    const [selectedNews, setSelectedNews] = useState(null);
    const [redactedIsOpen, setRedactedIsOpen] = useState(false);
    const {isUserAdmin} = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const [news, setNews] = useState([]);
    const [photoRedacted, setPhotoRedacted] = useState(false);

    let page = 1;
    let size = 10;

    function openNewsForm() {
        setIsOpen(true);
    }

    function closeNewsForm() {
        setIsOpen(false);
    }

    const refreshNews = useCallback(() => {
        try {
            const response = getNews(page, size)
            response.then(res => {
                setNews(res.data)
            });
        } catch (err) {
            setNews([]);
        }
    }, [page, size]);

    useEffect(() => {
        try {
            const response = getNews(page, size)
            response.then(res => {
                setNews(res.data)
            });
        } catch (err) {
            setNews([]);
        }
    }, [page, size])

    return (
        <NewsContext.Provider
            value={{
                redactedIsOpen,
                setRedactedIsOpen,
                deleteIsOpen,
                setDeleteIsOpen,
                selectedNews,
                setSelectedNews,
                refreshNews,
                photoRedacted,
                setPhotoRedacted
            }}
        >
            <AnimatedPage>
                <div className={`container ${classes.wrapper}`}>
                    <div className="row">
                        <div className={`col-12`}>
                            <div className={`d-flex flex-column ${classes.main_image}`}>
                                <h1>
                                    Богослужение каждое воскресенье в 10:00
                                </h1>
                                <div className={classes.down_subtitle}>
                                    <h5>
                                        Адрес:
                                    </h5>
                                    <div
                                        className={`d-flex flex-column flex-xl-row justify-content-between ${classes.wrapper_more}`}>
                                        <div className={`mb-3 mb-md-3 mb-sm-3 ${classes.wrapper_address}`}>
                                            <a href="https://yandex.ru/maps/10990/gelendgik/?ll=38.076254%2C44.547407&mode=routes&rtext=44.547461%2C38.076454~55.755800%2C37.617300&rtt=auto&ruri=~&z=20"
                                               className={`me-2 ${classes.icon}`}
                                               rel='noreferrer'>
                                                <img src={yandex_map} alt=""/>
                                            </a>
                                            <div className={classes.text}>
                                                Краснодарский край, г. Геленджик,
                                                ул. Грибоедова, д. 29
                                            </div>
                                        </div>
                                        <div className={classes.wrapper_who}>
                                            <div className={classes.text}>
                                                Пастор Щербаков Алексей Владимирович <br/>
                                                <a className={classes.text_href} href="tel:+79384831056">
                                                    <b>+7 (938) 483 - 10 - 56</b>
                                                </a>
                                            </div>
                                            <a href="https://t.me/voteyra" target="_blank"
                                               className={`ms-2 ${classes.icon}`}
                                               rel='noreferrer'>
                                                <img src={telegram} alt=""/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.parent}>
                                {isUserAdmin && (
                                    <div>
                                        <CreateButton text={'Добавить новость'} onClick={openNewsForm}></CreateButton>
                                        <CreateNewsForm isOpen={isOpen} onClose={closeNewsForm}
                                                        onCreate={refreshNews}></CreateNewsForm>
                                    </div>
                                )}
                            </div>
                        </div>
                        <DeleteNewsForm onDelete={refreshNews}/>
                        <UpdatePhotoForm/>
                        <div>

                            {news?.length > 0 && (
                                <h1 className="text-center">Новости церкви</h1>
                            )}

                            <div className="row">
                                {news && news.map((el) => (
                                    <div className="col-12 col-md-12 col-lg-6 mb-4" key={el.id}>
                                        <News isUserAdmin={isUserAdmin} el={el} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                </div>
            </AnimatedPage>
        </NewsContext.Provider>
    );
};


export default Main;
